///<reference path="./node.d.ts" />
// Web UI script.
"use strict";
var ast_1 = require('./ast');
var bfml_1 = require('./bfml');
var alt_1 = require('./alt');
var nba_1 = require('./nba');
var dot_1 = require('./dot');
var ltlParser = require('./ltl').parser;
var viz = require('viz.js');
document.addEventListener('DOMContentLoaded', function (ev) {
    // イベントを設定
    document.querySelector('#convert-button').addEventListener('click', function (e) {
        var fml = document.querySelector('#ltl-formula').value;
        convert(fml);
    }, false);
    // あれ
    var cs = document.querySelectorAll('input.ltl-sample-button');
    var l = cs.length;
    console.log(l);
    var _loop_1 = function(i) {
        var b = cs[i];
        b.addEventListener('click', function (e) {
            document.querySelector('#ltl-formula').value = b.getAttribute('data-sample');
        }, false);
    };
    for (var i = 0; i < l; i++) {
        _loop_1(i);
    }
});
// LTL formulaが入力されました
function convert(fml) {
    var exp = tryLTLParse(fml);
    if (exp == null) {
        return;
    }
    var result = document.querySelector('#result');
    empty(result);
    result.insertAdjacentHTML('beforeend', "<p>Rendering... (It may take time)</p>");
    setTimeout(function () {
        empty(result);
        result.insertAdjacentHTML('beforeend', "<h2>Results</h2>");
        // LTL formulaをshow
        showLTLFormula(result, 'Input LTL formula:', exp);
        // normalizeする
        var exp2 = exp.normalize();
        showLTLFormula(result, 'Normalized LTL formula:', exp2);
        // ABAを得る
        var aba = alt_1.toABA(exp2);
        showABA(result, 'Alternating Büchi Automaton:', aba);
        // NBAにしてdot
        var nba = nba_1.toNBA(aba);
        var dot = dot_1.toDot(nba);
        showDot(result, 'Nondeterministic Büchi Automaton:', dot);
    }, 0);
}
function tryLTLParse(fml) {
    try {
        var exp = ltlParser.parse(fml);
        return exp;
    }
    catch (e) {
        // 文法エラーだ！
        var err = document.querySelector('#error');
        var pre = document.createElement('pre');
        pre.textContent = e.message;
        empty(err);
        err.appendChild(pre);
        return null;
    }
}
// XXX HTMLエスケープとかが雑（多分問題ないけど）
function showLTLFormula(region, title, exp) {
    var ltlh = LTLtoHTML(exp)[0];
    var html = "<div class=\"region\">\n        <p>" + title + "</p>\n        <p class='ltl-formula'>" + ltlh + "</p>\n</div>";
    region.insertAdjacentHTML('beforeend', html);
}
function LTLtoHTML(exp) {
    if (exp instanceof ast_1.C) {
        return [("<i class='ltl-constant'>" + String(exp.value) + "</i>"), true];
    }
    else if (exp instanceof ast_1.Prop) {
        return [("<var class='ltl-prop'>" + exp.name + "</var>"), true];
    }
    else if (exp instanceof ast_1.Not) {
        var op = atom(LTLtoHTML(exp.op));
        return [("<i class='ltl-op'>\u00AC</i>" + op), true];
    }
    else if (exp instanceof ast_1.Or) {
        var op1 = atom(LTLtoHTML(exp.op1));
        var op2 = atom(LTLtoHTML(exp.op2));
        return [(op1 + "<i class='ltl-op'>\u2228</i>" + op2), false];
    }
    else if (exp instanceof ast_1.And) {
        var op1 = atom(LTLtoHTML(exp.op1));
        var op2 = atom(LTLtoHTML(exp.op2));
        return [(op1 + "<i class='ltl-op'>\u2227</i>" + op2), false];
    }
    else if (exp instanceof ast_1.Implies) {
        var op1 = atom(LTLtoHTML(exp.op1));
        var op2 = atom(LTLtoHTML(exp.op2));
        return [(op1 + "<i class='ltl-op'>\u2283</i>" + op2), false];
    }
    else if (exp instanceof ast_1.X) {
        var op = atom(LTLtoHTML(exp.op));
        return [("<i class='ltl-op-char'>X</i>" + op), true];
    }
    else if (exp instanceof ast_1.F) {
        var op = atom(LTLtoHTML(exp.op));
        return [("<i class='ltl-op-char'>F</i>" + op), true];
    }
    else if (exp instanceof ast_1.G) {
        var op = atom(LTLtoHTML(exp.op));
        return [("<i class='ltl-op-char'>G</i>" + op), true];
    }
    else if (exp instanceof ast_1.U) {
        var op1 = atom(LTLtoHTML(exp.op1));
        var op2 = atom(LTLtoHTML(exp.op2));
        return [(op1 + "<i class='ltl-op-char'>U</i>" + op2), false];
    }
    else if (exp instanceof ast_1.R) {
        var op1 = atom(LTLtoHTML(exp.op1));
        var op2 = atom(LTLtoHTML(exp.op2));
        return [(op1 + "<i class='ltl-op-char'>R</i>" + op2), false];
    }
    else {
        return ['', true];
    }
    function atom(_a) {
        var str = _a[0], a = _a[1];
        if (!a) {
            return "(" + str + ")";
        }
        else {
            return str;
        }
    }
}
// ABAをテーブルで表示
function showABA(result, title, aba) {
    var alphabet = aba.alphabet, states = aba.states, transition = aba.transition, initial = aba.initial, accepting = aba.accepting;
    var tdhs = alphabet.map(function (a) {
        return "<th>{" + a + "}</th>";
    }).join('');
    var trs = states.map(function (q, i) {
        var map = transition[q];
        var tds = alphabet.map(function (a) {
            var bfml = map[a];
            var html = BFmlToHTML(bfml)[0];
            var tags = [];
            if (q === initial) {
                tags.push('init');
            }
            if (accepting.indexOf(q) >= 0) {
                tags.push('F');
            }
            var tagstr = tags.length > 0 ? "(" + tags.join(',') + ")" : '';
            return "<td>" + html + "</td>";
        }).join('');
        var tags = [];
        if (q === initial) {
            tags.push('init');
        }
        if (accepting.indexOf(q) >= 0) {
            tags.push('F');
        }
        var tagstr = tags.length > 0 ? "(" + tags.join(',') + ")" : '';
        return "<tr>\n    <td>q<sub>" + i + "</sub>" + tagstr + "</td>\n    " + tds + "\n</tr>";
    }).join('');
    var html = "<div class=\"region\">\n        <p>" + title + "</p>\n        <table class='aba-table'>\n            <thead>\n                <tr>\n                    <td></td>\n                    " + tdhs + "\n                </tr>\n            </thead>\n            <tbody>\n                " + trs + "\n            </tbody>\n        </table>\n</div>";
    console.log(html);
    result.insertAdjacentHTML('beforeend', html);
    function BFmlToHTML(bfml) {
        if (bfml instanceof bfml_1.BExp) {
            var i = states.indexOf(bfml.exp.hash);
            return [("q<sub>" + i + "</sub>"), true];
        }
        else if (bfml instanceof bfml_1.BConst) {
            return [("<i class='bfml-constant'>" + String(bfml.value) + "</i>"), true];
        }
        else if (bfml instanceof bfml_1.BOr) {
            var op1 = atom(BFmlToHTML(bfml.op1));
            var op2 = atom(BFmlToHTML(bfml.op2));
            return [(op1 + "<i class='bfml-op'>\u2228</i>" + op2), false];
        }
        else if (bfml instanceof bfml_1.BAnd) {
            var op1 = atom(BFmlToHTML(bfml.op1));
            var op2 = atom(BFmlToHTML(bfml.op2));
            return [(op1 + "<i class='bfml-op'>\u2227</i>" + op2), false];
        }
        // XXX This is copy!
        function atom(_a) {
            var str = _a[0], a = _a[1];
            if (!a) {
                return "(" + str + ")";
            }
            else {
                return str;
            }
        }
    }
}
//dotを表示
function showDot(result, title, dot) {
    var svg = viz(dot, {
        engine: 'dot',
        format: 'svg',
    });
    var dataurl = 'data:image/svg+xml;base64,' + btoa(svg);
    var html1 = "<div class=\"region\">\n        <p>" + title + "</p>\n        <div>\n            <img src=\"" + dataurl + "\" class=\"graph\">\n        </div>\n        <p><a href=\"" + dataurl + "\" target=\"_blank\">Too small? Click here to open in proper size</a></p>\n    </div>";
    result.insertAdjacentHTML('beforeend', html1);
    var html = "<div class=\"region\">\n    <p>" + title + " (in the DOT format)</p>\n    <pre class=\"dot\"><code>" + dot + "</code></pre>\n</div>";
    result.insertAdjacentHTML('beforeend', html);
}
function empty(elm) {
    while (elm.hasChildNodes()) {
        elm.removeChild(elm.firstChild);
    }
}
function sample(text) {
    document.querySelector('#ltl-formula').value = text;
}



/*****************
 ** WEBPACK FOOTER
 ** ./dist/web.js
 ** module id = 0
 ** module chunks = 1
 **/


/*****************
 ** WEBPACK FOOTER
 ** ./dist/web.js
 ** module id = 0
 ** module chunks = 1
 **/